import { createFeatureSelector } from '@ngrx/store';
import { PlanSubscriptionDataState } from '@store/plan-subscription/plan-subscription.firestore.reducer';
import { FIRESTORE_COLLECTION_SUBSCRIPTIONS } from '@store/firestore/allFirestoreCollections';

export const subscriptionDataState = createFeatureSelector<PlanSubscriptionDataState>(
  FIRESTORE_COLLECTION_SUBSCRIPTIONS
);
